<template>
  <div class="col-span-2 datav-border rounded-lg p-4 datav-gradient" style="height: 100%; display: flex; flex-direction: column;">
    <h2 class="text-lg font-semibold mb-4 flex items-center gap-2">
      <i class="fa fa-list-ul text-primary"></i>设备列表
    </h2>
    <div class="space-y-3 device-list overflow-y-auto pr-2">
      <!-- 动态设备列表 -->
      <div v-for="device in devices" :key="device.id" class="bg-dark-light rounded p-3 hover:bg-primary/10 cursor-pointer transition flex justify-between items-center device-item" :class="{ active: selectedDeviceId === device.id }" @click="handleSelectDevice(device.id)">
        <div class="flex items-center gap-2">
          <span :class="`w-2 h-2 rounded-full point-${device.status}`"></span>
          <span>{{ device.name }}</span>
        </div>
        <i class="fa fa-chevron-right text-xs text-text-secondary"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceList',
  data() {
    return {
      selectedDeviceId: 'xuefengshan',
      devices: [
          { id: 'xuefengshan', name: '雪峰山发射基地动环监测', status: 'warning' },
          { id: 'city', name: '市区发射基地动环监测', status: 'normal' },
          { id: 'transmitter', name: '雪峰山发射基地发射机监测', status: 'normal' },
          // { id: 'xuefengshan_global', name: '雪峰山发射基地全域监测', status: 'normal' }
        ]
    };
  },
  methods: {
    handleSelectDevice(deviceId) {
      this.selectedDeviceId = deviceId;
      // 更新所有设备状态：选中项为warning，其他为normal
      this.devices = this.devices.map(device => ({
        ...device,
        status: device.id === deviceId ? 'warning' : 'normal'
      }));
      this.$emit('select-device', deviceId);
    }
  }
};
</script>

<style lang="scss" scoped>
.device-list {
  flex-grow: 1;
  overflow-y: auto;
}

.device-item.active {
  background-color: rgba(22, 93, 255, 0.1);
  border: 1px solid rgba(22, 93, 255, 0.3);
}
</style>